/**
 * Edit-administrator: business-error mapper.
 *
 * Reuses the shared `AdministratorFormError` union but pins the Edit-flow
 * default message ("Failed to update administrator."). The `validation` variant
 * is produced by the saga directly; this maps the infra failures
 * (`network` | `api`) for load / update / archive.
 */
import { classifyInfraError } from '@/utils/infra-error';

import type { AdministratorFormError } from '../../_shared/domain/administrator-form-error';

export type { AdministratorFormError as EditAdministratorError };

export function toEditAdministratorError(e: unknown): AdministratorFormError {
  return classifyInfraError(e, 'Failed to update administrator.');
}
